var $d92f6e92c51016e2$exports = {};
$d92f6e92c51016e2$exports = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


export {$d92f6e92c51016e2$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
